import Vue from 'vue'
import Router from 'vue-router'
import {logoutCall} from '../libs/api/api'
import store from '../store'
import routes from './routes'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
Vue.use(Router)

const router = new Router({
  routes,
  mode: (process.env && process.env.VUE_APP_LOCAL && process.env.VUE_APP_LOCAL === 'local') ? 'hash' : 'history',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})
function logout () {
  if (localStorage.getItem('accuraAuthToken') !== null) logoutCall({}).catch(error => error)
	store.dispatch('clearInformationPortalStore')
	let lang = localStorage.getItem('lang')
	localStorage.clear();
  localStorage.setItem('lang', lang || 'en-GB')
}
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) document.title = ((to.meta && to.meta.title) || 'Accura');
  if (to.meta && to.meta.requiresAuth && localStorage.getItem('accuraAuthToken') === null) {
    sessionStorage.setItem('redirectPath', to.path);
    logout()
    next({name: 'signin-page'})
  } 
  else next()
})

export default router